"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = require("./ListItem.styled");

var _Icon = require("../Icon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var CheckBoxOutlineBlankIcon = function CheckBoxOutlineBlankIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }), _react.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

CheckBoxOutlineBlankIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var CheckBoxIcon = function CheckBoxIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), _react.default.createElement("path", {
    d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }));
};

CheckBoxIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var ListItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ListItem, _PureComponent);

  function ListItem(props) {
    var _this;

    _classCallCheck(this, ListItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListItem).call(this, props));

    _this.onListItemClick = function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;
      if (!disabled && onClick) onClick(event);
    };

    _this.renderDefaultList = function () {
      var _this$props2 = _this.props,
          itemKey = _this$props2.itemKey,
          id = _this$props2.id,
          children = _this$props2.children,
          hasCheckbox = _this$props2.hasCheckbox,
          selected = _this$props2.selected,
          styleFor = _this$props2.styleFor,
          rest = _objectWithoutProperties(_this$props2, ["itemKey", "id", "children", "hasCheckbox", "selected", "styleFor"]);

      var _this$state = _this.state,
          leftIcon = _this$state.leftIcon,
          rightIcon = _this$state.rightIcon,
          childrenWithoutIcons = _this$state.childrenWithoutIcons;
      var hasLeftIcon = hasCheckbox !== null && hasCheckbox === 'left';
      var hasRightIcon = hasCheckbox !== null && hasCheckbox === 'right';
      var showIconWrapper = hasLeftIcon || hasRightIcon || styleFor === 'default';
      return _react.default.createElement(_ListItem.StyledListItem, _extends({}, rest, {
        onClick: _this.onListItemClick,
        id: id || "list-item-".concat(itemKey),
        value: itemKey,
        selected: selected,
        hasLeftIcon: hasLeftIcon || !!leftIcon,
        hasRightIcon: hasRightIcon || !!rightIcon,
        styleFor: styleFor
      }), showIconWrapper && _react.default.createElement(_ListItem.StyledListItemIconWrapper, null, hasLeftIcon && _this.getCheckboxIcon() || leftIcon), _react.default.createElement(_ListItem.StyledChildrenWrapper, null, childrenWithoutIcons || children), showIconWrapper && _react.default.createElement(_ListItem.StyledListItemIconWrapper, null, hasRightIcon && _this.getCheckboxIcon() || rightIcon));
    };

    _this.renderArticleList = function () {
      var _this$props3 = _this.props,
          itemKey = _this$props3.itemKey,
          id = _this$props3.id,
          children = _this$props3.children,
          onClick = _this$props3.onClick,
          selected = _this$props3.selected,
          hasCheckbox = _this$props3.hasCheckbox,
          rest = _objectWithoutProperties(_this$props3, ["itemKey", "id", "children", "onClick", "selected", "hasCheckbox"]);

      var _this$state2 = _this.state,
          leftIcon = _this$state2.leftIcon,
          childrenWithoutIcons = _this$state2.childrenWithoutIcons;
      return _react.default.createElement(_ListItem.StyledArticleListItem, _extends({}, rest, {
        id: id || "list-item-".concat(itemKey)
      }), leftIcon && _react.default.createElement(_ListItem.StyledListItemIconWrapper, null, leftIcon), _react.default.createElement(_ListItem.StyledChildrenWrapper, null, childrenWithoutIcons || children));
    };

    _this.renderListItem = {
      default: function _default() {
        return _this.renderDefaultList();
      },
      pill: function pill() {
        return _this.renderDefaultList();
      },
      article: function article() {
        return _this.renderArticleList();
      }
    };
    _this.state = {
      leftIcon: null,
      rightIcon: null,
      childrenWithoutIcons: null
    };
    return _this;
  }

  _createClass(ListItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var children = this.props.children;

      if (children && children.length > 1) {
        var childrenWithoutIcons = children.slice(); // Left Icon

        if (children[0].type === _Icon.Icon) {
          childrenWithoutIcons.splice(0, 1);
          this.setState({
            leftIcon: children[0]
          });
        } // Right Icon


        if (children[children.length - 1].type === _Icon.Icon) {
          childrenWithoutIcons.splice(childrenWithoutIcons.length - 1, 1);
          this.setState({
            rightIcon: children[children.length - 1]
          });
        }

        this.setState({
          childrenWithoutIcons: childrenWithoutIcons
        });
      }
    }
  }, {
    key: "getCheckboxIcon",
    value: function getCheckboxIcon() {
      var _this$props4 = this.props,
          selected = _this$props4.selected,
          color = _this$props4.color;
      return _react.default.createElement(_Icon.Icon, {
        color: color
      }, selected ? _react.default.createElement(CheckBoxIcon, null) : _react.default.createElement(CheckBoxOutlineBlankIcon, null));
    }
    /**
     * Calls the onClick function propagates item object
     * @param {Object} event The click event
     */

  }, {
    key: "render",
    value: function render() {
      var styleFor = this.props.styleFor;
      return this.renderListItem[styleFor]();
    }
  }]);

  return ListItem;
}(_react.PureComponent);
/**
 * Definition of default values for component props
 */


exports.ListItem = ListItem;
ListItem.defaultProps = {
  color: undefined,
  disabled: false,
  selected: false,
  hasCheckbox: null,
  onClick: function onClick() {},
  className: undefined,
  id: undefined,
  styleFor: 'default'
};
ListItem.propTypes = {
  children: _propTypes.default.any.isRequired,
  itemKey: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  color: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  hasCheckbox: _propTypes.default.oneOf([null, 'left', 'right']),
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  styleFor: _propTypes.default.oneOf(['default', 'pill', 'article'])
};